export default __webpack_public_path__ + "static/media/oneplay.2cf3bbe1.jpg";